import { useState } from 'react';
import { formatMoney, lineSum, type OrderItem } from '@dastarhan/core';

/**
 * Сплит по позициям: отмеченное уходит в оплату текущим чеком,
 * остальное остаётся открытым заказом стола (со СЛЕДУЮЩИМ номером).
 * Скидка и гость остаются на оплачиваемой части — это сказано явно.
 */
export function SplitDialog({ items, onConfirm, onCancel }: {
  items: OrderItem[];
  onConfirm: (selectedIds: string[]) => void;
  onCancel: () => void;
}) {
  const [picked, setPicked] = useState<Set<string>>(new Set());
  const toggle = (id: string) =>
    setPicked((s) => {
      const next = new Set(s);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });

  const selectedSum = items
    .filter((i) => picked.has(i.itemId))
    .reduce((s, i) => s + lineSum(i), 0);
  const valid = picked.size >= 1 && picked.size < items.length;

  return (
    <div className="dialog-backdrop" role="dialog" aria-modal="true" aria-label="Разделить чек">
      <div className="dialog" style={{ maxWidth: 420, width: '100%' }}>
        <span className="eyebrow">Разделить чек</span>
        <h1>Что оплачивают сейчас?</h1>
        <div className="split-list">
          {items.map((i) => (
            <label key={i.itemId} className={`split-line ${picked.has(i.itemId) ? 'on' : ''}`}>
              <input type="checkbox" checked={picked.has(i.itemId)}
                onChange={() => toggle(i.itemId)} />
              <span className="name">{i.name}{i.qty !== 1 ? ` × ${i.qty}` : ''}</span>
              <b className="money">{formatMoney(lineSum(i))}</b>
            </label>
          ))}
        </div>
        <p className="hint" style={{ margin: 0 }}>
          Остальное останется открытым на этом столе отдельным чеком.
          Скидка и гость — на оплачиваемой части.
        </p>
        <div className="mod-actions" style={{ width: '100%' }}>
          <button className="btn ghost" onClick={onCancel}>Отмена</button>
          <button className="btn accent" disabled={!valid}
            onClick={() => onConfirm([...picked])}>
            Оплатить {formatMoney(selectedSum)}
          </button>
        </div>
      </div>
    </div>
  );
}
